module.exports = __webpack_public_path__ + "static/media/S2N9-5.898d94f4.svg";